import { SIGNUP_TEXT } from "../../domain/constants/constants";
import { styles as s } from "../../styles/signupstyles";

type Props = {
  onClick?: () =>void;
};

export default function AppleButton({
  onClick,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={s.appleButton}
    >
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className={s.socialIcon}
      >
        <path d="M17.05 12.54c-.02-2.2 1.8-3.26 1.88-3.31-1.03-1.5-2.62-1.71-3.19-1.73-1.36-.14-2.65.8-3.34.8-.69 0-1.75-.78-2.88-.76-1.48.02-2.85.86-3.61 2.19-1.54 2.67-.39 6.62 1.11 8.79.73 1.06 1.6 2.25 2.74 2.21 1.1-.04 1.52-.71 2.85-.71 1.33 0 1.71.71 2.88.69 1.19-.02 1.94-1.08 2.67-2.15.84-1.23 1.18-2.42 1.2-2.48-.03-.01-2.3-.88-2.32-3.5zM14.88 5.78c.6-.73 1.01-1.75.9-2.78-.87.04-1.93.58-2.56 1.31-.56.64-1.05 1.68-.92 2.67.97.08 1.97-.49 2.58-1.2z" />
      </svg>

      {SIGNUP_TEXT.apple}
    </button>
  );
}